export const profileSchema = [
  { key: "prenom", value: "Prénom" },
  { key: "nom", value: "Nom" },
  { key: "dateDeNaissance", value: "Date de naissance" },
  { key: "lieuDeNaissance", value: "Lieu de naissance" },
  { key: "addresse", value: "Adresse" },
  { key: "ville", value: "Ville" },
  { key: "codePostal", value: "Code postal" },
  { key: "intitule", value: "Intitulé (optionnel)" },
];

export const reasons = [
  {
    shortText: "Travail",
    code: "travail",
    position: ["x", 47, 553, 12],
    icon: "building",
  },
  {
    shortText: "Achats",
    code: "achats_culturel_cultuel",
    position: ["x", 47, 482, 12],
    icon: "shopping-cart",
  },
  {
    shortText: "Santé",
    code: "sante",
    position: ["x", 47, 434, 12],
    icon: "heartbeat",
  },
  {
    shortText: "Famille",
    code: "famille",
    position: ["x", 47, 410, 12],
    icon: "users",
  },
  {
    shortText: "Handicap",
    code: "handicap",
    position: ["x", 47, 373, 12],
    icon: "wheelchair",
  },
  {
    shortText: "Sport",
    code: "sport_animaux",
    position: ["x", 47, 349, 12],
    icon: "running",
  },
  {
    shortText: "Convocation",
    code: "convocation",
    position: ["x", 47, 276, 12],
    icon: "balance-scale",
  },
  {
    shortText: "Mission",
    code: "missions",
    position: ["x", 47, 252, 12],
    icon: "hands-helping",
  },
  {
    shortText: "Enfants",
    code: "enfants",
    position: ["x", 47, 228, 12],
    icon: "baby",
  },
];
